import React, { Component } from 'react'
import Footer from '../../../../_components/common/Footer';
import NavBar from '../../../../_components/common/Navbar';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';
import Page404 from '../../../404page';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';

import { validation, cellValidation } from '../../UploadDemographicData/validation';


import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css'

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../../_components/common/Form2/index.css';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { connect } from 'react-redux';

import * as Papa from 'papaparse';


import { UploadAssessmentAction } from '../../../../_actions/organisations/UploadAssessmentAction.action';
import { organisationAction } from '../../../../_actions/organisation.action';
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action';





import './../../UploadDemographicData';

import './uploadAssessment.css';

class UploadAssessment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uploadSuccess: false,
            orgId: 0,
            sellerId: 0,

            batchList: [],

            chooseFile: false,
            csvData: [],
            validateDisability: false,
            uploadDisability: false,
            csvErrorPosition: {},
            work_experience: 50,
            validationText: 'VALIDATE',


            currentInstrumentId: 0,
            currentBatchId: null,

            readOnlyCsv: false,
            breadCrumbData: [],


            hasProperOrgId: true,
            idLoader: true,
            errSaveIndex: [],

            uploadloader: false
        }
    }

    componentDidMount() {

        const { dispatch } = this.props;

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");

        dispatch(organisationAction.getOrganisation((callback_Data) => {
            let hasId = false
            for (let i = 0; i < callback_Data.data.organisation_list.length; i++) {
                const element = callback_Data.data.organisation_list[i];
                if (element.id == orgIdFromPath) {
                    hasId = true
                }
            }

            this.setState({
                hasProperOrgId: hasId,
                idLoader: false,
            })
        }))

        this.setState({
            orgId: orgIdFromPath
        }, () => {
            let sellerIdLocal = localStorage.getItem('seller_id')
            let orgIdLocal = localStorage.getItem('orgId')
            if (sellerIdLocal !== 'null' || orgIdLocal !== 'null') {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.orgId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'UPLOAD ASSESSMENTS'
                        }
                    ]
                }, () => {
                    if (orgIdLocal !== 'null') {
                        this.setState({
                            breadCrumbData: [
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'UPLOAD ASSESSMENTS'
                                }
                            ],
                        })
                    }
                })
            } else {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.orgId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'UPLOAD ASSESSMENTS'
                        }
                    ]
                })
            }
        })



    }

    componentDidUpdate(prevProps, prevState) {
        const { demoGraphicCsvUpload } = this.props

        if (prevProps.demoGraphicCsvUpload !== demoGraphicCsvUpload) {
            if (demoGraphicCsvUpload.demoGraphicCsvUpload_error === false && demoGraphicCsvUpload.demoGraphicCsvUpload_loading === false) {
                let toastIdDemoGrpahicUpload = toast['info'](`CSV UPLOADED SUCCESSFULLY`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastIdDemoGrpahicUpload, {
                    render: `CSV UPLOADED SUCCESSFULLY`,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            } else if (demoGraphicCsvUpload.demoGraphicCsvUpload_error === true) {
                let toastIdDemoGrpahicUpload = toast['error'](`CSV UPLOAD FAILED`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });
            }
        }

        if (prevProps.organisationList !== this.props.organisationList) {
            if (this.props.organisationList.length !== 0) {
                let sellerId = 0
                for (let i = 0; i < this.props.organisationList.length; i++) {
                    const element = this.props.organisationList[i];
                    if (element.id == this.state.orgId) {
                        sellerId = element.seller__id
                    }
                }
                this.setState({
                    sellerId
                }, () => {
                    const { dispatch } = this.props;
                    const { orgId, sellerId } = this.state;

                    dispatch(manageBatchActions.getBatchList({
                        orgId,
                        sellerId,
                    }));

                    dispatch(manageBatchActions.allotAssessmentInstrumentListAction({
                        sellerId,
                        orgId
                    }));

                })
            }
        }
    }

    chooseFileFunc = (showModal) => {
        this.setState({
            chooseFile: showModal
        })
    }
    chooseFileAction = (data) => {
        if (!this.isValidFileType(data)) {
            return;
        }

        Papa.parse(data, {
            complete: (results) => this.handleParseResults(results)
        });
    }

    isValidFileType = (data) => {
        if (!data.name.toLowerCase().endsWith('.csv')) {
            this.handleInvalidFileType();
            return false;
        }
        return true;
    }

    handleParseResults = (results) => {
        if (this.isEmptyFile(results.data)) {
            this.handleInvalidCsv("CSV file is empty");
            return;
        }

        const headers = results.data[0];
        if (this.hasMissingColumns(headers)) {
            return;
        }

        const nonEmptyRows = this.removeEmptyRows(results.data);
        if (nonEmptyRows.length === 1) {
            this.handleInvalidCsv("CSV file contains headers but no data");
            return;
        }

        this.processValidCsv(nonEmptyRows);
    }

    isEmptyFile = (data) => {
        return data.length === 0 || (data.length === 1 && data[0].every(cell => cell === ''));
    }

    hasMissingColumns = (headers) => {
        const requiredColumns = ['email', 'expiry_date', 'short_name', 'full_name', 'gender'];
        const missingColumns = requiredColumns.filter(col => !headers.includes(col));
        if (missingColumns.length > 0) {
            this.handleInvalidCsv(`Missing required columns: ${missingColumns.join(', ')}`);
            return true;
        }
        return false;
    }

    removeEmptyRows = (data) => {
        return data.filter((row, index) => index === 0 || row.some(cell => cell !== ''));
    }

    processValidCsv = (nonEmptyRows) => {
        const currentDate = new Date().getTime();
        let properCsvData = [];
        let errorCounterForValidDate = false;

        nonEmptyRows.forEach((val, key) => {
            if (key === 0) {
                properCsvData.push(val);
            } else {
                const processedRow = this.processRow(val, currentDate);
                properCsvData.push(processedRow.row);
                errorCounterForValidDate = errorCounterForValidDate || processedRow.hasInvalidDate;
            }
        });

        this.updateState(properCsvData, errorCounterForValidDate);
    }

    processRow = (row, currentDate) => {
        let processedRow = [];
        let hasInvalidDate = false;

        row.forEach((value, index) => {
            if (index === 1) {
                const valueDate = new Date(value).getTime();
                if (currentDate > valueDate) {
                    hasInvalidDate = true;
                }
            }
            processedRow.push(value);
        });

        return { row: processedRow, hasInvalidDate };
    }

    updateState = (properCsvData, errorCounterForValidDate) => {
        this.setState({
            csvData: properCsvData,
            errSaveIndex: [],
            validationText: 'VALIDATE',
            readOnlyCsv: false,
            uploadDisability: false,
            validateDisability: this.state.currentInstrumentId !== 0
        }, () => {
            if (errorCounterForValidDate) {
                toast.warn("Some expiry dates are in the past", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                });
            }
        });
    }

    handleInvalidFileType = () => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(`Please upload a CSV file`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        });
    }



    handleInvalidCsv = (errorMessage) => {
        this.setState({
            csvData: [],
            errSaveIndex: [],
            validateDisability: false,
        }, () => {
            toast.error(errorMessage, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        });
    }
    validateCsvFunc = () => {
        this.setState({
            uploadDisability: false,
            validateDisability: !this.state.validateDisability,
            validationText: this.state.validationText === 'VALIDATE' ? 'VALIDATING...' : 'GETTING CSV READY TO EDIT...'
        }, () => {
            setTimeout(() => {
                if (this.state.validationText === 'VALIDATING...') {
                    this.performValidation();
                } else if (this.state.validationText === 'GETTING CSV READY TO EDIT...') {
                    this.setState({
                        readOnlyCsv: false,
                        uploadDisability: false,
                        validationText: 'VALIDATE'
                    });
                }
                this.setState({
                    validateDisability: !this.state.validateDisability,
                });
            }, 1300);
        });
    }

    performValidation = () => {
        if (this.state.csvData.length === 0) return;

        const headers = this.state.csvData[0];
        const { newCsvArray, validationResults } = this.validateRows(headers);

        if (validationResults.csvValidationState) {
            this.handleSuccessfulValidation(newCsvArray);
        } else {
            this.handleFailedValidation(newCsvArray, validationResults.saveIndex,
                validationResults.duplicateEmails, validationResults.emptyFields);
        }
    }

    validateRows = (headers) => {
        let csvValidationState = true;
        let saveIndex = [];
        let emailSet = new Set();
        let duplicateEmails = new Set();
        let newCsvArray = [headers];
        let emptyFields = [];

        for (let i = 1; i < this.state.csvData.length; i++) {
            const row = this.state.csvData[i];
            if (this.isRowEmpty(row)) continue;

            const rowValidation = this.validateRow(row, headers, i, emailSet);

            csvValidationState = csvValidationState && rowValidation.isValid;
            if (!rowValidation.isValid) {
                saveIndex.push({ col: rowValidation.invalidColumns, row: i });
            }

            duplicateEmails = new Set([...duplicateEmails, ...rowValidation.duplicateEmails]);
            emptyFields = [...emptyFields, ...rowValidation.emptyFields];

            if (rowValidation.email) emailSet.add(rowValidation.email);
            newCsvArray.push(row);
        }

        return {
            newCsvArray,
            validationResults: { csvValidationState, saveIndex, duplicateEmails, emptyFields }
        };
    }

    validateRow = (row, headers, rowIndex, emailSet) => {
        let isValid = true;
        let invalidColumns = [];
        let duplicateEmails = new Set();
        let emptyFields = [];

        headers.forEach((header, index) => {
            if (!row[index] || row[index].trim() === '') {
                invalidColumns.push(index);
                emptyFields.push(`Row ${rowIndex + 1}, ${header}`);
                isValid = false;
            }
        });

        const email = row[0];
        if (this.isInvalidEmail(email, emailSet)) {
            invalidColumns.push(0);
            isValid = false;
            if (email && email !== '' && emailSet.has(email)) {
                duplicateEmails.add(email);
            }
        }

        const expiryDate = row[1];
        if (this.isInvalidExpiryDate(expiryDate)) {
            invalidColumns.push(1);
            isValid = false;
        }

        return { isValid, invalidColumns, duplicateEmails, emptyFields, email };
    }

    isInvalidEmail = (email, emailSet) => {
        return email === '' || email === undefined || !validation.isEmailAddress(email) || emailSet.has(email);
    }

    isInvalidExpiryDate = (expiryDate) => {
        return expiryDate === '' || expiryDate === undefined || !validation.isProperDate(expiryDate);
    }

    isRowEmpty = (row) => {
        return row.every(cell => cell === '' || cell === undefined);
    }

    handleSuccessfulValidation = (newCsvArray) => {
        toast.info(`CSV VALIDATED SUCCESSFULLY`, {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 1500,
        });
        this.setState({
            csvData: newCsvArray,
            readOnlyCsv: true,
            validationText: 'EDIT CSV',
            uploadDisability: this.state.currentInstrumentId !== 0
        });
    }

    handleFailedValidation = (newCsvArray, saveIndex, duplicateEmails, emptyFields) => {
        let errorMessages = [];
        if (duplicateEmails.size > 0) {
            errorMessages.push(`Duplicate emails found: ${Array.from(duplicateEmails).join(', ')}`);
        }
        if (emptyFields.length > 0) {
            errorMessages.push(`Empty required fields: ${emptyFields.join(', ')}`);
        }
        errorMessages.push('CSV VALIDATION FAILED');

        toast.error(errorMessages.join('\n'), {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 5000,
        });

        this.showErrorHighlightHOT(saveIndex);
        this.setState({
            csvData: newCsvArray,
            readOnlyCsv: true,
            uploadDisability: false,
            validationText: 'EDIT CSV'
        });
    }

    cellbeforechange = (c, s) => {
        this.state.csvData[c[0][0]][c[0][1]] = c[0][3]

        let editedErrored = false

        this.state.errSaveIndex.map(indexes => {
            indexes.col.map(colD => {
                if (c[0][0] === indexes.row && c[0][1] === colD) {
                    if (c[0][2] !== c[0][3]) {
                        editedErrored = true
                    }
                }
            })
        })

        if (editedErrored) {
            const errorIndexArr = this.state.errSaveIndex.map(indexes => {
                return {
                    ...indexes,
                    col: indexes.col.filter(colD => {
                        return indexes.row !== c[0][0] || (indexes.row === c[0][0] && colD !== c[0][1])
                    })
                }
            })

            this.setState({
                errSaveIndex: errorIndexArr
            })
        }
    }



    showErrorHighlightHOT(saveIndex) {
        this.setState({
            errSaveIndex: saveIndex,
        })
    }

    hotAfterValidate = (isValid, value, row, prop, source) => {

    }

    uploadCsvFunc = () => {
        const { dispatch } = this.props;
        let csvJson = this.csvJSON(this.state.csvData);
        let uploadingCsvData = this.processUploadingData(csvJson);

        const UploadingData = this.prepareUploadData(uploadingCsvData);

        this.dispatchUploadAction(dispatch, UploadingData);

        this.setState({ uploadloader: true });
    }

    processUploadingData = (csvJson) => {
        return csvJson.map(element => {
            if (element.expiry_date !== undefined) {
                element.expiry_date = this.formatExpiryDate(element.expiry_date);
            }

            return {
                email: element.email,
                expiry_date: element.expiry_date,
                full_name: element.full_name,
                short_name: element.short_name,
                gender: this.mapGender(element.gender)
            };
        });
    }

    formatExpiryDate = (dateString) => {
        let [day, month, year] = dateString.split(/[/\-]/);
        month = this.convertMonthToNumber(month.toLowerCase());
        year = this.ensureFourDigitYear(year);
        return `${year}-${month}-${day.padStart(2, '0')}`;
    }

    convertMonthToNumber = (month) => {
        const monthMap = {
            'jan': '01', 'feb': '02', 'mar': '03', 'apr': '04', 'may': '05', 'jun': '06',
            'jul': '07', 'aug': '08', 'sep': '09', 'oct': '10', 'nov': '11', 'dec': '12'
        };

        if (monthMap[month]) return monthMap[month];
        if (month.length === 3) {
            let monthNumber = Object.keys(monthMap).findIndex(m => m.startsWith(month)) + 1;
            return monthNumber.toString().padStart(2, '0');
        }
        return month; // Return original if no conversion found
    }

    ensureFourDigitYear = (year) => {
        return year.length === 2 ? '20' + year : year;
    }

    mapGender = (gender) => {
        return gender === 'Male' ? 1 : gender === 'Female' ? 2 : 3;
    }

    prepareUploadData = (uploadingCsvData) => {
        return {
            details_length: uploadingCsvData.length,
            organisation: this.state.orgId,
            seller: this.state.sellerId,
            batch: this.state.currentBatchId,
            instrument: this.state.currentInstrumentId,
            details: uploadingCsvData
        };
    }

    dispatchUploadAction = (dispatch, UploadingData) => {
        dispatch(
            UploadAssessmentAction.UploadAssessmentActionApi(
                UploadingData,
                {
                    sellerId: this.state.sellerId,
                    orgId: this.state.orgId,
                },
                manageBatchActions.allotAssessmentInstrumentListAction,
                this.handleUploadResponse
            )
        );
    }

    handleUploadResponse = (UploadAssessmentActionApi_Data) => {
        if (UploadAssessmentActionApi_Data) {
            if (UploadAssessmentActionApi_Data.data.errors.length === 0) {
                this.setState({
                    csvData: [],
                    errSaveIndex: [],
                    uploadSuccess: true,
                    currentInstrumentId: 0,
                });
            } else {
                this.setState({ uploadSuccess: false });
            }
        }
        this.setState({ uploadloader: false });
    }

    csvJSON(csv) {

        var lines = csv;

        var result = [];

        var headers = lines[0];

        for (var i = 1; i < lines.length; i++) {

            var obj = {};
            var currentline = lines[i];

            for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }

            result.push(obj);

        }


        return result;
    }

    chooseInstrument = (e) => {
        if (e.target.value !== 'Choose an Option...') {
            this.setState({
                currentInstrumentId: parseInt(e.target.value)
            }, () => {
                if (this.state.validateDisability === false && this.state.csvData.length > 0) {
                    this.setState({
                        validateDisability: true
                    })
                }
                if (this.state.validationText === 'EDIT CSV' && this.state.uploadDisability === false) {
                    this.setState({
                        uploadDisability: true,
                    })
                }
            })
        } else {
            this.setState({
                uploadDisability: false,
                currentInstrumentId: 0,
                validateDisability: false,
                readOnlyCsv: false,
                validationText: 'VALIDATE'
            })
        }
    }

    chooseBatches = (e) => {
        if (e.target.value !== 'Choose an Option...') {
            this.setState({
                currentBatchId: parseInt(e.target.value)
            })
        } else {
            this.setState({
                currentBatchId: null
            })
        }
    }

    toggle = () => {
        const { dispatch } = this.props;

        this.setState({
            uploadDisability: !this.state.uploadDisability
        }, () => {
            dispatch({
                type: 'REQUEST_UPLOAD_ASSESSMENT_API',
            })
        })
    }




    render() {
        const { batchList, instrumentList, uploaded_assessment_error, uploaded_assessment_loading, uploaded_assessment_data, uploaded_assessment_error_data } = this.props;

        return (
            <div className="position-relative custom-container">
                <NavBar />
                {this.renderContent()}
                {this.renderChooseFileModal()}
                <Footer />
            </div>
        );
    }

    renderContent() {
        if (this.state.idLoader) {
            return this.renderLoader();
        }
        return this.state.hasProperOrgId ? this.renderMainContent() : <Page404 />;
    }

    renderLoader() {
        return (
            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                <LoaderComp color={'black'} />
            </div>
        );
    }

    renderMainContent() {
        return (
            <div className="container" style={{ marginTop: 20, marginBottom: 20 }}>
                {this.renderUploadModal()}
                <CommonBreadCrumb data={this.state.breadCrumbData} />
                {this.renderSelectionArea()}
                {this.renderUploadArea()}
                {this.renderHotTable()}
            </div>
        );
    }

    renderUploadModal() {
        const { uploaded_assessment_data, uploaded_assessment_error, uploaded_assessment_error_data } = this.props;
        if (uploaded_assessment_data.message !== '' && this.state.uploadDisability) {
            return this.renderSuccessModal();
        }
        if (uploaded_assessment_error) {
            return this.renderErrorModal();
        }
        return null;
    }

    renderSuccessModal() {
        const { uploaded_assessment_data } = this.props;
        return (
            <Modal isOpen={this.state.uploadDisability} toggle={this.toggle} centered={true}>
                <ModalHeader toggle={this.toggle} className="bg-black text-white text-uppercase custom-header">
                    Upload Assessment
                </ModalHeader>
                <ModalBody>
                    {this.renderModalContent(uploaded_assessment_data)}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderErrorModal() {
        const { uploaded_assessment_error_data } = this.props;
        return (
            <Modal isOpen={this.state.uploadDisability} toggle={this.toggle} centered={true}>
                <ModalHeader toggle={this.toggle} className="bg-black text-white text-uppercase custom-header">
                    Error Occurred!
                </ModalHeader>
                <ModalBody>
                    {uploaded_assessment_error_data}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderModalContent(data) {
        const isUploadFailed = data.errors.length === this.state.csvData.length - 1;
        return (
            <React.Fragment>
                <p style={{ fontSize: 20, textAlign: 'center', color: isUploadFailed ? 'red' : 'green' }}>
                    {isUploadFailed ? 'Upload Failed' : data.message}
                </p>
                {this.renderErrorDetails(data)}
            </React.Fragment>
        );
    }

    renderErrorDetails(data) {
        if (data.errors.length === 0) return null;
        return (
            <div style={{ fontSize: 14 }}>
                <p style={{ fontSize: 12, marginTop: '2.4rem' }}>Following assessments could not be added because of the following errors.</p>
                {data.errors.map((val, index) => (
                    <div key={index} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr' }}>
                        <p style={{ textDecoration: 'underline' }}>{Object.keys(val)[0]}</p>
                        <p>:</p>
                        <p>{val[Object.keys(val)[0]]}</p>
                    </div>
                ))}
            </div>
        );
    }

    renderSelectionArea() {
        return (
            <div className="container">
                <div className="row resUploadAssessment">
                    {this.renderBatchSelection()}
                    {this.renderInstrumentSelection()}
                </div>
            </div>
        );
    }

    renderBatchSelection() {
        return (
            <div className="col-6 resUABatch" style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <p className="resAssBatchTitle">Batch</p>
                <select className="batchSelect" style={{ width: 250, marginLeft: '15px' }} onChange={(e) => this.chooseBatches(e)}>
                    <option>Unallotted</option>
                    {this.props.batchList.map(val => (
                        <option key={val.id} value={val.id}>{val.batch_name}</option>
                    ))}
                </select>
            </div>
        );
    }

    renderInstrumentSelection() {
        return (
            <div className="col-6" style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <p className="resAssInstumentTitle">Instrument<span className="mandatory-star">*</span></p>
                <select className="batchSelect" value={this.state.currentInstrumentId} style={{ width: 250 }} onChange={(e) => this.chooseInstrument(e)}>
                    <option>Choose an Option...</option>
                    {this.props.instrumentList.map(val => (
                        <option key={val.organisation_assessment_credit__instrument} value={val.organisation_assessment_credit__instrument}>
                            {`${val.organisation_assessment_credit__instrument__instrument_name} (${val.unsold_credits})`}
                        </option>
                    ))}
                </select>
            </div>
        );
    }

    renderUploadArea() {
        return (
            <React.Fragment>
                <div className="instrument-select-message">
                    <p>** Please select an instrument</p>
                </div>
                <div className="bg-green rounded-top animation-fade-in">
                    <p className="text-center text-uppercase py-2 text-white mb-0">ASSESSMENTS UPLOAD</p>
                </div>
                <div className="container animation-fade-in" style={{ backgroundColor: '#5e5e5e' }}>
                    <div className="row p-2" >
                        <div className="pl-2 pr-2" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            {this.renderUploadButtons()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderUploadButtons() {
        return (
            <React.Fragment>
                <button
                    className="btn btn-red btn-sm text-uppercase m-1"
                    onClick={() => this.chooseFileFunc(true)}
                    disabled={this.state.currentInstrumentId === 0}
                >
                    CHOOSE FILE
                </button>
                <button
                    className="btn btn-red btn-sm text-uppercase m-1"
                    disabled={!this.state.validateDisability || this.state.uploadSuccess}
                    onClick={() => this.validateCsvFunc()}
                >
                    {this.state.validationText}
                </button>
                <button
                    className="btn btn-red btn-sm text-uppercase m-1"
                    style={{ width: 100 }}
                    disabled={!this.state.uploadDisability || this.state.uploadSuccess}
                    onClick={() => this.uploadCsvFunc()}
                >
                    {this.state.uploadloader ? <i className="fa fa-spinner fa-spin"></i> : 'UPLOAD'}
                </button>
            </React.Fragment>
        );
    }

    renderHotTable() {
        return (
            <HotTable
                data={this.state.csvData}
                colHeaders={true}
                rowHeaders={true}
                ref="hot"
                beforeChange={this.cellbeforechange}
                className={"animation-fade-in"}
                width="100%"
                height="600"
                stretchH="all"
                readOnly={this.state.readOnlyCsv}
                columns={this.getHotTableColumns()}
                afterValidate={this.hotAfterValidate}
                cells={this.getHotTableCellProperties}
            />
        );
    }

    getHotTableColumns() {
        return [{
            validator: cellValidation.isEmailAddress,
            placeholder: 'Email address',
            placeholderCellClassName: 'hot-placeholder',
        }, {
            validator: cellValidation.isProperDate,
            placeholder: 'eg: 01/Feb/2018',
            placeholderCellClassName: 'hot-placeholder',
        }, {}, {}, {
            placeholder: 'Select Gender',
            editor: 'select',
            selectOptions: ['Female', 'Male', 'Others']
        }];
    }

    getHotTableCellProperties = (row, col, prop) => {
        var cellProperties = {};
        if (row === 0) {
            cellProperties.readOnly = true;
        }
        this.state.errSaveIndex.forEach(indexes => {
            indexes.col.forEach(colD => {
                if (row === indexes.row && col === colD) {
                    cellProperties.className = 'cellErrorInvalid';
                }
            });
        });
        return cellProperties;
    }

    renderChooseFileModal() {
        if (!this.state.chooseFile) return null;
        return (
            <ModalNew2
                heading="CHOOSE FILE"
                showModal={this.state.chooseFile}
                formData={[{
                    key: 'chooseFile',
                    type: 'file',
                    accept: '.csv',
                    value: '',
                    valid: false,
                    regex: ".+",
                    elementConfig: {
                        name: 'chooseFile',
                        label: '',
                        placeholder: 'Choose a file'
                    },
                    validation: {
                        required: false,
                        message: "is required"
                    },
                }]}
                action={this.chooseFileAction.bind(this)}
                toggleModal={this.chooseFileFunc.bind(this)}
                viewMessage={[{ text: '' }]}
                triggerType={"CANCEL"}
                singleButton={true}
                onlyCancel={true}
            />
        );
    }
}

const mapStateToProps = state => {

    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const organisationList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : [];

    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : [];

    const { instrument_list_error, instrument_list_loading } = state.instrumentList;
    const instrumentList = (!instrument_list_error && !instrument_list_loading) ? state.instrumentList.instrument_list.data.organisation_credit_list : [];

    const { uploaded_assessment_error, uploaded_assessment_loading, uploaded_assessment_error_data } = state.uploadAssessment;
    const uploaded_assessment_data = (!uploaded_assessment_error && !uploaded_assessment_loading) ? state.uploadAssessment.uploaded_assessment_data : { errors: [], message: '' }


    return (
        {

            demoGraphicCsvUpload: state.demoGraphicCsvUpload,

            organisationList,
            orgError,
            orgLoading,

            batch_list_error,
            batch_list_loading,
            batchList,

            instrument_list_error,
            instrument_list_loading,
            instrumentList,

            uploaded_assessment_error,
            uploaded_assessment_loading,
            uploaded_assessment_data,
            uploaded_assessment_error_data,

        }
    )
}

export default connect(mapStateToProps)(UploadAssessment)


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/UploadAssessment.jsx